module.exports = __webpack_public_path__ + "img/change-line.ef9ad247.png";